import React from 'react';

export const toastClassName = 'auto-switched-currency-toast';
export const toastSpinnerClassName = 'auto-switched-currency-toast-spinner';

export const toastStyles: Record<string, React.CSSProperties> = {
  portal: {
    position: 'fixed',
    bottom: 24,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'center',
    zIndex: 9999999,
    pointerEvents: 'none',
  },
  content: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    minWidth: 0,
    flexWrap: 'nowrap',
  },
  message: {
    flex: '1 1 auto',
    minWidth: 0,
    fontSize: 14,
    lineHeight: '20px',
    color: '#FFFFFF',
  },
  actions: {
    flex: '0 0 auto',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 16,
    alignSelf: 'center',
  },
  undoButton: {
    padding: 0,
    border: 0,
    background: 'transparent',
    color: '#FFFFFF',
    font: 'inherit',
    fontSize: 14,
    lineHeight: '20px',
    textDecoration: 'underline',
    textUnderlineOffset: 2,
    cursor: 'pointer',
  },
};

export const toastStyleOverrides = `
  .${toastClassName}.${toastClassName} {
    width: min(600px, calc(100vw - 32px));
    max-width: 600px;
    min-height: 56px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    background-color: #000000;
    border: 0;
    border-radius: 2px;
    box-shadow: none;
    pointer-events: auto;
    overflow: hidden;
  }

  .${toastClassName}.${toastClassName} > span[role='presentation']:first-child {
    flex: 0 0 24px;
    min-width: 24px;
  }

  .${toastClassName}.${toastClassName} > span[data-hook='message'] {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    min-width: 0;
    margin: 16px 0;
    max-height: none;
    line-height: 20px;
    overflow: visible;
  }

  .${toastSpinnerClassName}.${toastSpinnerClassName} {
    margin-right: 12px;
    animation: autoSwitchToastSpinnerRotate 2s linear infinite;
    transform-origin: center;
  }

  .${toastSpinnerClassName}.${toastSpinnerClassName} circle {
    stroke: #FFFFFF;
    animation: autoSwitchToastSpinnerDash 1.5s ease-in-out infinite;
  }

  .${toastClassName} [data-hook='closeButton'] {
    width: 18px;
    height: 18px;
    min-width: 18px;
    min-height: 18px;
    color: #FFFFFF;
    --wix-ui-tpa-icon-button-icon-color: 255, 255, 255;
  }

  .${toastClassName}.${toastClassName} > div {
    flex: 0 0 auto;
    height: 56px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    align-self: center;
    margin-left: 0;
  }

  .${toastClassName} [data-hook='closeButton'] svg {
    width: 18px;
    height: 18px;
  }

  .${toastClassName} [data-hook='closeButton'] svg,
  .${toastClassName} [data-hook='closeButton'] path {
    fill: #FFFFFF;
    stroke: #FFFFFF;
  }

  @keyframes autoSwitchToastSpinnerRotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes autoSwitchToastSpinnerDash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }

    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;
